import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { CategoryParentInput } from './Inputs';
import { InputGuesser, EditGuesser } from '@api-platform/admin';
import { useFormState } from 'react-hook-form';
import {
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  TranslatableInputs,
  TextInput,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import {
  validateDescription,
  validateMenuName,
  validateName,
  validatePositionInMenu,
  validateSortOrder,
} from '../../validators/category';
import {
  validateSeoDescription,
  validateSeoKeywords,
  validateSeoTitle,
} from '../../validators/common';
import { getSelectedCompanyFilterValue } from '../../helper/filter';

export const CategoryEdit = (props) => {
  const [iconImageChanged, setIconImageChanged] = useState(false);
  const [featuredImageChanged, setFeaturedImageChanged] = useState(false);

  const transform = (data) => {
    if (
      data['iconImage']['mediaObject'] === null ||
      data['iconImage']['mediaObject'].length === 0
    ) {
      data['iconImage'] = null;
    }

    if (
      data['featuredImage']['mediaObject'] === null ||
      data['featuredImage']['mediaObject'].length === 0
    ) {
      data['featuredImage'] = null;
    }

    if (data['parent']) {
      data['parent'] = data.parent['@id'];
    } else {
      data['parent'] = null;
    }

    data['iconImageUpdated'] = iconImageChanged;
    data['featuredImageUpdated'] = featuredImageChanged;

    data['translations'] = {
      de: {
        '@id': '/category_translations/' + data.translationsFormView.id.de,
        name: data.translationsFormView.name.de,
        menuName: data.translationsFormView.menuName.de,
        description: data.translationsFormView.description.de,
        seoTitle: data.translationsFormView.seoTitle.de,
        seoDescription: data.translationsFormView.seoDescription.de,
        seoKeywords: data.translationsFormView.seoKeywords.de,
        nameInSearchField: data.translationsFormView.nameInSearchField.de,
        nameInFilter: data.translationsFormView.nameInFilter.de,
        nameInBreadcrumb: data.translationsFormView.nameInBreadcrumb.de,
        locale: 'de',
      },
      // en: {
      //   '@id': '/category_translations/' + data.translationsFormView.id.en,
      //   name: data.translationsFormView.name.en,
      //   menuName: data.translationsFormView.menuName.en,
      //   description: data.translationsFormView.description.en,
      //   seoTitle: data.translationsFormView.seoTitle.en,
      //   seoDescription: data.translationsFormView.seoDescription.en,
      //   seoKeywords: data.translationsFormView.seoKeywords.en,
      //   locale: 'en',
      // },
    };

    return data;
  };
  return (
    <EditGuesser {...props} transform={transform}>
      <EditInputs
        iconImageChanged={iconImageChanged}
        handleIconImageChange={setIconImageChanged}
        featuredImageChanged={featuredImageChanged}
        handleFeaturedImageChange={setFeaturedImageChanged}
      />
    </EditGuesser>
  );
};

const EditInputs = (props) => {
  const { dirtyFields } = useFormState();

  const {
    iconImageChanged,
    featuredImageChanged,
    handleIconImageChange,
    handleFeaturedImageChange,
  } = props;

  useEffect(() => {
    if (dirtyFields['iconImage']) {
      handleIconImageChange(true);
    } else {
      handleIconImageChange(false);
    }
  }, [dirtyFields['iconImage']]);

  useEffect(() => {
    if (dirtyFields['featuredImage']) {
      handleFeaturedImageChange(true);
    } else {
      handleFeaturedImageChange(false);
    }
  }, [dirtyFields['featuredImage']]);

  console.log('dirtyFields: ', dirtyFields);
  console.log('iconImageChanged: ', iconImageChanged);
  console.log('featuredImageChanged: ', featuredImageChanged);

  return (
    <Grid container spacing={4} sx={{ p: 2 }}>
      <Grid item xs={6}>
        <ReferenceInput
          source="company"
          reference="companies"
          label="Company"
          // filterToQuery={(searchText) => ({ name: searchText })}
        >
          <SelectInput
            disabled
            fullWidth
            source="company"
            // validate={validateCompany}
            optionText="name"
          />
        </ReferenceInput>
        <CategoryParentInput
          edit={true}
          company={getSelectedCompanyFilterValue()}
        />
        <InputGuesser fullWidth source={'showInMenu'} />
        <InputGuesser
          fullWidth
          source={'positionInMenu'}
          validate={validatePositionInMenu}
        />
        <InputGuesser
          fullWidth
          source={'sortOrder'}
          validate={validateSortOrder}
        />
        <ReferenceInput
          source="iconImage.mediaObject"
          reference="media_objects"
          label="Icon"
        >
          <AutocompleteInput
            fullWidth
            optionText="fileName"
            filterToQuery={(q) => ({ fileName: q })}
          />
        </ReferenceInput>
        <ReferenceInput
          source="featuredImage.mediaObject"
          reference="media_objects"
          label="Icon"
        >
          <AutocompleteInput
            fullWidth
            optionText="fileName"
            filterToQuery={(q) => ({ fileName: q })}
          />
        </ReferenceInput>
        <TranslatableInputs locales={['de']} defaultLocale="de">
          <TextInput
              label={'Name in Search field'}
              source="translationsFormView.nameInSearchField"
          />
          <TextInput
              label={'Name in filter'}
              source="translationsFormView.nameInFilter"
          />
          <TextInput
              label={'Name in breadcrumb'}
              source="translationsFormView.nameInBreadcrumb"
          />
        </TranslatableInputs>
      </Grid>
      <Grid item xs={6}>
        <TranslatableInputs locales={['de']} defaultLocale="de">
          <TextInput
            fullWidth
            label={'Name'}
            source="translationsFormView.name"
            validate={validateName}
          />
          <TextInput
            fullWidth
            label={'MenuName'}
            source="translationsFormView.menuName"
            validate={validateMenuName}
          />
          <RichTextInput
            fullWidth
            label={'Description'}
            source="translationsFormView.description"
            validate={validateDescription}
            format={(v) => (v ? v : '')}
            parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
          />
          <TextInput
            fullWidth
            label={'Seo Title'}
            source="translationsFormView.seoTitle"
            validate={validateSeoTitle}
          />
          <TextInput
            fullWidth
            label={'Seo Description'}
            source="translationsFormView.seoDescription"
            validate={validateSeoDescription}
            multiline
            rows={5}
          />
          <TextInput
            fullWidth
            label={'Seo Keywords'}
            source="translationsFormView.seoKeywords"
            validate={validateSeoKeywords}
            multiline
            rows={5}
          />
        </TranslatableInputs>
      </Grid>
    </Grid>
  );
};
